'use client';
import { isConvertibleColor } from '../../../modules/colors/impl/validators/validators.js';
import { toRGBA } from '../../../modules/colors/impl/toRGBA/toRGBA.js';

var createDarkener = function(alpha) {
    return function(channel) {
        return Math.round(channel * (1 - alpha));
    };
};
var darken = function(color, alpha) {
    if (!isConvertibleColor(color)) {
        return color;
    }
    var _toRGBA = toRGBA(color), r = _toRGBA.r, g = _toRGBA.g, b = _toRGBA.b, a = _toRGBA.a;
    var dark = createDarkener(alpha);
    return "rgba(" + dark(r) + ", " + dark(g) + ", " + dark(b) + ", " + a + ")";
};

export { createDarkener, darken };
